import { NeedDto, UserDto } from '@act/shared/data-transfer-objects';
import { DateTime } from 'luxon';
import { timeFormatter } from '@act/shared/utilities';

function calculateRemainingDays(expiresAt: number): number {
  return timeFormatter.differenceInDaysFromNow(expiresAt);
}

function formatNeedDateLine(need: NeedDto, member?: UserDto) {
  const indentifiedAt = timeFormatter.epochToHumanReadableDate({
    date: need.identifiedAt,
  });

  const remainingDays = calculateRemainingDays(need.expiresAt);

  let durationCopy;

  const isEditable = member && needIsEditable(need, member);

  if (remainingDays >= 0 && isEditable) {
    durationCopy =
      remainingDays > 0 ? `${remainingDays} days remaining` : 'Last day';
  } else {
    durationCopy = 'Closed';
  }

  return `${indentifiedAt} · ${durationCopy}`;
}

type NeedLabel = 'Fulfilled' | 'Identified' | 'Stopped pursuing' | 'Unresolved';

function calculateNeedLabel(need: NeedDto, member: UserDto): NeedLabel {
  if (need.fulfilledAt) {
    return 'Fulfilled';
  }

  if (need.abandonedAt) {
    return 'Stopped pursuing';
  }

  if (
    !need.fulfilledAt &&
    (calculateRemainingDays(need.expiresAt) < 0 ||
      member?.memberStage?.key === 'independence')
  ) {
    return 'Unresolved';
  }

  return 'Identified';
}

function needIsEditable(need: NeedDto, member: UserDto) {
  if (!need || !member?.memberStage) {
    // be conservative and say need is closed if we don't have enough information
    return false;
  }
  if (need.memberId !== member.id) {
    return false;
  }
  const isExpired = need.expiresAt < DateTime.now().toMillis();
  if (
    need.fulfilledAt &&
    member.memberStage?.key !== 'independence' &&
    !isExpired
  ) {
    return true;
  }
  return (
    !isExpired &&
    !need.abandonedAt &&
    member.memberStage?.key !== 'independence'
  );
}

const syvaNeedsUtils = {
  calculateNeedLabel,
  calculateRemainingDays,
  formatNeedDateLine,
  needIsEditable,
};

export default syvaNeedsUtils;
